import { render, staticRenderFns } from "./UcHeaderGuide.vue?vue&type=template&id=9a8febaa&"
import script from "./UcHeaderGuide.vue?vue&type=script&lang=js&"
export * from "./UcHeaderGuide.vue?vue&type=script&lang=js&"
import style0 from "./UcHeaderGuide.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports